import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Spin, Row, Col, Select, Input, Pagination, DatePicker } from 'antd';

import { Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { SortIcon } from '../../components';
// import { formItemLayout } from 'constants/layout';

// import { connect } from 'react-redux';
import { TableHelper } from 'helpers/Table';

import { getClassSchedules } from 'data/schedule';
// import Utils from 'utils/utils';

import classes from '../styles/class/ClassInfo.module.scss';
import moment from 'moment';
import { formatNumber } from 'utils/formatting';

const pageLimit = 20;
const Confirm = Modal.confirm;
const Option = Select.Option;

// @connect(
//   (state) => ({
//     schedulesLoading: state.schedule.scheduleListWaiting,
//     schedules: state.schedule.classSchedules.results,
//     classroom: state.classroom.classDetail,
//     page: state.schedule.classSchedules.page || 1,
//     classCount: state.schedule.classSchedules.count,
//     serviceFeeLevel: state.config.serviceFee,
//   }),
//   { getClassSchedules }, //, activeArticle, recommendArticle, unrecommendArticle, deleteArticle }
// )
export default class ClassSchedules extends Component {
  // static propTypes = {
  //   schedules: PropTypes.array.isRequired,
  //   schedulesLoading: PropTypes.bool,
  //   page: PropTypes.number,
  //   classCount: PropTypes.number,
  //   serviceFeeLevel: PropTypes.array,
  //   classroom: PropTypes.any,
  //   // form: PropTypes.Any,
  // };

  constructor(props) {
    super(props);
    this.onClickRow = this.onClickRow.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.changeCategory = this.changeCategory.bind(this);
    this.changeSubcategory = this.changeSubcategory.bind(this);
    this.changeType = this.changeType.bind(this);

    this.state = {
      collapseMobile: [],
      schedules: [],
      showModal: false,
      selectedStatus: 'all',
      page: props.page,
      displaySearchValue: '',
      searchValue: '',
      searchBy: '',
      selectedCategory: 'all',
      selectedSubcategory: 'all',
      selectedType: 'all',
      selectedRowKeys: [],
      start: moment(),
      end: moment().add(1, 'month'),
    };
  }

  componentDidMount = async () => {
    // const schedules = await getClassSchedules(this.props.classroom._id);
    // this.setState(schedules);
    this.loadData();
  };

  componentWillMount() {
    // this.setState({
    //   showModal: false,
    // });
  }
  loadData = async (query) => {
    this.setState({
      loading: true,
    });
    const schedules = await getClassSchedules(this.props.classroom._id, query);
    this.setState({
      schedules: schedules.results,
      page: schedules.currentPage,
      count: schedules.count,
      loading: false,
    });
    window.scrollTo(0, 0);
  };

  onClickRow(record, index) {
    console.log(record, index);
    // browserHistory.push(`/class/${record.slug}`);
  }

  onChangePage = (page) => {
    this.setState({ page }, () => {
      this.loadData(this.getCurrentQuery());
      // this.props.getClassSchedules(this.props.classroom._id, this.getCurrentQuery());
    });
  };

  onReload = () => {
    this.loadData(this.getCurrentQuery());
    // this.props.getClassSchedules(this.props.classroom._id, this.getCurrentQuery());
  };

  onTableChange = (a, b, sorter) => {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onReload);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onReload);
    }
  };

  getCurrentQuery() {
    return {
      page: this.state.page,
      sortBy: this.state.sortBy,
    };
  }

  changeCategory(category) {
    this.setState({
      selectedCategory: category,
      selectedSubcategory: 'all',
    });
  }

  changeSubcategory(subcategory) {
    this.setState({
      selectedSubcategory: subcategory,
    });
  }

  changeType(event) {
    console.log(event);
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  columns = [
    {
      columnName: 'code',
      title: 'No.',
      dataIndex: 'code',
      render: (value, record) => (
        <div>
          <Link to={`/class/${record.class._id}/schedule/${record._id}`}>{value} </Link>
          {record.remark && <Icon type="pushpin" />}
        </div>
      ),
      sorter: true,
    },
    {
      columnName: 'date',
      title: 'Sche.\nDate',
      dataIndex: 'start',
      render: (value, record) => {
        if (record.scheduleType === 'multiple') {
          const start = moment(record.start);
          const end = moment(record.end);
          return (
            <span>
              {start.format('DD/MM/YYYY')} - {end.format('DD/MM/YYYY')}
            </span>
          );
        }
        return moment(record.start).format('DD/MM/YYYY');
      },
      sorter: true,
    },

    {
      columnName: 'status',
      title: 'Status',
      dataIndex: 'status',
      render: (value, record) => {
        if (record.isDeleted === true) {
          return 'Cancelled';
        } else if (record.isClosed === true) {
          return 'Closed';
        } else if (record.isSummary === true) {
          return 'Completed';
        }
        return 'Upcoming';
      },
      sorter: true,
    },

    {
      columnName: 'registered',
      title: 'Regis.',
      dataIndex: 'classCapacity',
      render: (value, record) => `${record.studentEnroll} / ${value}`,
    },
    {
      columnName: 'refPrice',
      title: 'Ref.\nPrice',
      dataIndex: 'class.price',
      render: (value) => formatNumber(value),
    },
    {
      columnName: 'price',
      title: 'Price',
      dataIndex: 'price',
      render: (value) => formatNumber(value),
    },
    {
      ...TableHelper.priceColumn("Teacher's\nRev", 'transferableAmount'),
    },
    {
      ...TableHelper.percentColumn('%Com\nDisc', 'feeDiscount'),
    },
    {
      ...TableHelper.priceColumn('Net Com', 'serviceFee'),
    },
    {
      ...TableHelper.priceColumn('Proc.\nFee', 'cardFee'),
    },
    {
      ...TableHelper.priceColumn('Payout', 'teacherRevenue'),
    },

    // {
    //   columnName: 'command',
    //   title: '',
    //   dataIndex: '',
    //   render: (value) => {
    //     return (
    //       <div>
    //         &nbsp;&nbsp;&nbsp;&nbsp;
    //         <Icon type="schedule" className={classes.commandIcon} />
    //       </div>
    //     );
    //   },
    // },
  ];

  classStatuses = [
    { label: 'All', value: 'all', column: 'all' },
    { label: 'Completed', value: 'recommend', column: 'approved' },
    { label: 'Cancelled', value: 'rejected', column: 'rejected' },
    { label: 'Closed', value: 'closed', column: 'closed' },
  ];

  renderContentTable() {
    const rs = this.props.revenueSummaries;
    const content = this.state.schedules.reduce((results, singleContent, key) => {
      if (singleContent.scheduleType === 'flexible') {
        return results;
      }
      singleContent.key = key;
      const revSum = _.find(rs, { schedule: singleContent._id });
      let renderContent = singleContent;
      if (revSum) {
        renderContent = { ...revSum, ...singleContent };
        let transferableAmount = renderContent.classRevenue;
        transferableAmount -= renderContent.discountList.reduce((result, discountItem) => {
          result += discountItem.amount;
          return result;
        }, 0);
        transferableAmount += renderContent.additionalList.reduce((result, additionalItem) => {
          result += additionalItem.amount;
          return result;
        }, 0);
        renderContent.transferableAmount = transferableAmount;
      }
      results.push(renderContent);
      console.log(renderContent);
      return results;
    }, []);

    return (
      <div>
        <Table columns={this.columns} dataSource={content} bordered pagination={false} onChange={this.onTableChange} scroll={{ x: 1500 }} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }
  renderOfferingSchedule() {
    if (this.props.classroom.classType !== 'flexible' || this.props.schedules.length <= 0) {
      return <div />;
    }
    const schedule = this.props.schedules[0];
    const classId = this.props.classroom._id;

    return (
      <div className="content">
        <div className={cn(classes.offeringScheduleContainer, 'ant-card-head-title')}>
          <span className="bold">Offering Schedule:</span> <Link to={`/class/${classId}/schedule/${schedule._id}/offering`}>Time table</Link>
        </div>
      </div>
    );
  }

  renderCalendarFooter() {
    return (
      <div className="text-center">
        <a onClick={() => this.onUpdateCalendar(1)}>1 Months</a> |&nbsp;
        <a onClick={() => this.onUpdateCalendar(3)}>3 Months</a> |&nbsp;
        <a onClick={() => this.onUpdateCalendar(6)}>6 Months</a> |
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    return (
      <div>
        <div>{this.renderOfferingSchedule()}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!loading}>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}
